$(function () {
  // Reviewに対してFeedbackを送る
  $(document).on('click', '.js-helpful', function (e) {
    e.preventDefault();
    var _this = $(this);
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/home/review/feedback',
      data: {
        id: _this.data('id'),
        helpful: _this.data('helpful'),
        _csrf: window.tom.conf.csrfToken
      }
    }).done(function (res) {
      if (!res || res.status !== 'ok') {
        return;
      }

      // カウント部分を更新
      var _voteArea = _this.closest('.js-voteArea');
      _voteArea.find('.js-helpful > span').eq(0).text(res.feedback.positive);
      _voteArea.find('.js-helpful > span').eq(1).text(res.feedback.negative);

      // ボタンのデザインを変更
      _voteArea.find('.js-helpful').removeClass('is-feedback-selected');
      if (res.isFeedbacked) {
        _voteArea.addClass('is-feedbacked');
        _this.addClass('is-feedback-selected');
      } else {
        _voteArea.removeClass('is-feedbacked');
      }
    });
  });
});
